import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Injury } from '../assets/injury.svg?react'

export function PageAccessDenied() {
  const { t } = useTranslation()
  return (
    <div className='p-8 w-full text-center'>
      <div className='font-bold text-4xl leading-[2] flex-cc mb-4'>
        <div>{t('Access Denied')}</div>
        <Injury className='dark:fill-slate-900' width={64} height={64} />
      </div>
      <div className='text-base w-full'>
        <div className='max-w-[480px] m-auto'>{t("Access Denied Description")}</div>
      </div>
    </div>
  )
}
